import { availableStyles } from './clean-department-utils'
import { cleanEntityInclusions } from './clean-entity-inclusions'
import _ from 'lodash'

export function cleanModifiers (department, menuBlob, forPublish = false) {
  if (!_.has(department, 'modifiers')) return

  cleanModifierItems(menuBlob)

  const availableCategories = _.get(menuBlob, 'modifiers.categories', []).map(next => next.id)
  const availableItems = _.get(menuBlob, 'modifiers.items', []).map(next => next.id)

  cleanAvailability(department.modifiers, availableCategories, availableItems)
  cleanPricingSchemes(department.modifiers, menuBlob, forPublish)
  cleanDepartmentModifiers(department.modifiers, availableCategories, availableItems, menuBlob, department, forPublish)
  cleanStyles(department)
}

function cleanModifierItems (menuBlob) {
  const modifiers = _.get(menuBlob, 'modifiers')
  if (!modifiers) { return }
  const categories = modifiers.categories || []
  const catids = categories.map(cat => cat.id)
  modifiers.items = modifiers.items.filter(item => catids.indexOf(item.category) > -1)
}

function cleanAvailability (modifiers, availableCategories, availableItems) {
  const availability = modifiers.availability
  availability.categories = availability.categories.filter(catId => availableCategories.includes(catId))
  availability.items = availability.items.filter(({ id }) => availableItems.includes(id))
}

function cleanPricingSchemes (modifiers, menuBlob, forPublish) {
  const availableSchemes = menuBlob.pricingSchemes
    .filter(scheme => scheme.isActive !== false || !forPublish || scheme.$added)
    .map(scheme => scheme.id)
  modifiers.pricingSchemes = modifiers.pricingSchemes.filter(({ id }) => availableSchemes.includes(id))
}

function cleanDepartmentModifiers (modifiers, availableCategories, availableItems, menuBlob = null, department = null, forPublish = false) {
  for (let pricingScheme of modifiers.pricingSchemes) {
    pricingScheme.modifierCategories = pricingScheme.modifierCategories.filter(cat =>
      availableCategories.includes(cat.id) && cat === pricingScheme.modifierCategories.find(c => c.id === cat.id))
    pricingScheme.modifierItems = pricingScheme.modifierItems.filter(item =>
      availableItems.includes(item.id) && item === pricingScheme.modifierItems.find(i => i.id === item.id))
  }
  // forPublish will be set to 1 if it's a location-level UI request (i.e. not for publish) so we can know the difference here.
  if (department && forPublish === true) {
    var cleanIt = obj => { cleanEntityInclusions(obj, menuBlob, department.id, forPublish) }
    department.categories.forEach(cleanIt)
    department.items.forEach(cleanIt)
  }
}

function cleanStyles (department) {
  const modifiers = department.modifiers
  const styles = availableStyles(department)

  for (let pricingScheme of modifiers.pricingSchemes) {
    for (let category of pricingScheme.modifierCategories) {
      cleanAdditionPrices(category, styles)
      cleanOrderAlone(category, styles)
    }

    for (let item of pricingScheme.modifierItems) {
      cleanAdditionPrices(item, styles)
      cleanOrderAlone(item, styles)
    }
  }
}

function cleanAdditionPrices (element, availableStyles) {
  element.additionPrices = element.additionPrices
    .filter(price => price.flatRate || _.get(availableStyles, price.styleId, []).includes(price.optionId))
}

function cleanOrderAlone (element, availableStyles) {
  if (!element.hasOwnProperty('orderAlone')) return

  element.orderAlone.basePrice = element.orderAlone.basePrice
    .filter(price => price.flatRate || _.get(availableStyles, price.sizeId, []).includes(price.sizeOption))

  element.orderAlone.styleUpcharge = element.orderAlone.styleUpcharge
    .filter(price =>
      (price.flatRate || _.get(availableStyles, price.sizeId, []).includes(price.sizeOption)) &&
      _.get(availableStyles, price.styleId, []).includes(price.styleOption)
    )
}

export default {
  cleanAvailability,
  cleanPricingSchemes,
  cleanDepartmentModifiers,
  cleanStyles
}
